import { FormSelect } from "@/shared/forms";
import { useMemo } from "react";
import { useIngredientCategoriesLookupQuery } from "../api/ingredient-categories-queries";

const NONE = "__none__";

type IngredientCategoryFieldProps = {
  /** ຫມວດປິດໃຊ້ ຫຼື ບໍ່ຢູ່ໃນ lookup — ຍັງສະແດງໃນຟອມແກ້ໄຂ */
  fallbackOption?: { id: string; label: string };
};

export function IngredientCategoryField({
  fallbackOption,
}: IngredientCategoryFieldProps) {
  const lookup = useIngredientCategoriesLookupQuery();

  const options = useMemo(() => {
    const rows = lookup.data ?? [];
    const base = [
      { value: NONE, label: "— ບໍ່ລະບຸຫມວດ —" },
      ...rows.map((c) => ({
        value: c.id,
        label: c.code ? `${c.name} (${c.code})` : c.name,
      })),
    ];
    if (
      fallbackOption &&
      !base.some((o) => o.value === fallbackOption.id)
    ) {
      base.push({
        value: fallbackOption.id,
        label: `${fallbackOption.label} (ປິດໃຊ້)`,
      });
    }
    return base;
  }, [lookup.data, fallbackOption]);

  return (
    <FormSelect
      name="categoryId"
      label="ຫມວດວັດຖຸດິບ"
      options={options}
      placeholder={lookup.isLoading ? "ກຳລັງໂຫຼດ..." : "ເລືອກຫມວດ"}
    />
  );
}

export function categoryIdFromFormValue(value: string): string | null {
  return value === NONE || !value ? null : value;
}

export function categoryIdToFormValue(
  categoryId: string | null | undefined,
): string {
  return categoryId ?? NONE;
}
